<div class="site-request-modal">
    <div class="modal fade show" style="display:block;" tabindex="-1" role="dialog" aria-modal="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <!-- <button type="button" class="btn-close" (click)="closePopupEmitter.emit()"></button> -->
                    <button type="button" class="btn-close" (click)="closeModal()"></button>
                </div>

                <div class="modal-body popup-content">
                    <p class="popup-message">
                        Know what you can expect from <br><span>our reports
                            Get a Free Illustrated Deep Report</span> <br>with selected add-on options
                    </p>
                    <img src="images/svg/form-vector.svg" alt="Form Vector" class="popup-vector" />
                    <form [formGroup]="illustratedForm" (ngSubmit)="onSubmit()">
                        <div class="mb-3">
                            <input type="email" class="form-control" formControlName="email" name="email"
                                placeholder="Your Email*">
                            @if(illustratedForm.get('email')?.invalid &&
                            (illustratedForm.get('email')?.dirty || illustratedForm.get('email')?.touched)) {

                            @if(illustratedForm.get('email')?.errors?.['required']) {
                            <p class="error">Email is required</p>
                            }
                            @if(illustratedForm.get('email')?.errors?.['email']) {
                            <p class="error">Please enter a valid email</p>
                            }
                            }
                        </div>

                        <div class="mb-3">
                            <input type="text" class="form-control" formControlName="name" name="name"
                                placeholder="Your Name*">
                            @if(illustratedForm.get('name')?.invalid &&
                            (illustratedForm.get('name')?.dirty || illustratedForm.get('name')?.touched)) {

                            @if(illustratedForm.get('name')?.errors?.['required']) {
                            <p class="error">Name is required</p>
                            }
                            }
                        </div>

                        <div class="mb-3">
                            <input type="tel" class="form-control" formControlName="phone" name="phone"
                                placeholder="Your Phone Number">
                        </div>

                        <div class="mb-3"><input type="text" class="form-control" formControlName="company"
                                name="company" placeholder="Company"></div>
                        <p class="popup-message">By requesting an illustrated report, you agree to receive our
                            electronic
                            communications. Please be aware that we DO NOT sell your information; it is kept
                            confidential. </p>
                        <button type="submit" class="btn btn-primary">Submit Request</button>
                    </form>

                    @if (done()) {
                    <div class="thanks">
                        <h2>Thank you for your request.</h2>
                        <p>The report has been sent to your email.</p>
                        If you didn't receive it please <a routerLink="/contact-us">contact us</a>.
                    </div>
                    }
                </div>
            </div>
        </div>
    </div>
</div>